<template>
  <div class="homeCode">
    <div class="box">
      <div class="box-title">
        微信公众号阅读
        <span class="el-icon-close" @click="hideBox"></span>
      </div>
      <div class="box-list">
        <el-image :src="img.code" fit="fill"></el-image>
        <p>扫码关注公众号阅读</p>
      </div>
    </div>
  </div>
</template>

<script>
import code from "@/assets/img/home/code.png";

export default {
  data() {
    return {
      img: {
        code
      }
    };
  },
  methods: {
    hideBox() {
      this.$emit("hide");
    }
  }
};
</script>

<style lang="less">
.homeCode {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  .box {
    width: 600px;
    height: 500px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    &-title {
      position: relative;
      width: 600px;
      height: 90px;
      text-align: center;
      line-height: 90px;
      font-size: 28px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 4px;
      background: rgba(22, 82, 148, 1);
      border-radius: 10px 10px 0px 0px;
      .el-icon-close {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
      }
    }
  }
  .box-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: calc(100% - 90px);
    .el-image {
      width: 246px;
    }
  }
}
</style>
